import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { ModalCardComponent } from '@components/Modals/modal-card/modal-card.component';

@Component({
  selector: 'app-modal-max-order-exceeded',
  standalone: true,
  imports: [ModalCardComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './modal-max-order-exceeded.component.html',
})
export class ModalMaxOrderExceededComponent {
  title = input.required<string>();
  message = input<string | null>(null);
  currentOrdersLabel = input.required<string>();
  currentOrdersCount = input.required<number>();
  maxOrdersLabel = input.required<string>();
  maxOrdersCount = input.required<number>();
  backToSelectionLabel = input.required<string>();
  forcePassageLabel = input.required<string>();

  backToSelectionClick = output<void>();
  forcePassageClick = output<void>();
}
